import React from 'react'
import GrinMenuItem from 'components/common/menu/GrinMenuItem'
import IconAndText from 'components/common/IconAndText'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'

const GenericOptionMenuItem = ({ option, onClick }) => {
  return (
    <GrinMenuItem onClick={onClick}>
      <IconAndText icon={option.icon} text={<DazzedParagraph14 strong>{option.label}</DazzedParagraph14>} />
    </GrinMenuItem>
  )
}

export default GenericOptionMenuItem
